/**
 * report-problems event bus (T35.6.3).
 *
 * Mirrors the `feedback-events.ts` / `capture-events.ts` pattern: one
 * CustomEvent dispatched on `window`, one imperatively-callable opener.
 * The sheet mounted in AppShell listens for this event; every entry point
 * (AccountSheet, DealPriceReporter, ProductSearchReporter, ShoppingModeView)
 * calls `openReportProblemSheet` — no component refs, no context.
 */

import type { ReportItemContext } from './api';

export const REPORT_PROBLEM_OPEN_EVENT = 'report-problem:open';

export interface ReportProblemOpenDetail {
  /** The entity being reported (deal / product-search), if any. */
  itemContext?: ReportItemContext;
  /** The screen context string (human-readable page label). */
  screenContext?: string;
  /** Optional pre-seeded note (e.g. "Couldn't find: <term>"). */
  note?: string;
}

/**
 * Open the report-problem sheet, optionally pre-seeded with context.
 * Dispatched as a `CustomEvent<ReportProblemOpenDetail>` on `window`; the
 * sheet listener picks it up and renders with the supplied detail.
 */
export function openReportProblemSheet(detail: ReportProblemOpenDetail = {}): void {
  window.dispatchEvent(
    new CustomEvent<ReportProblemOpenDetail>(REPORT_PROBLEM_OPEN_EVENT, {
      detail,
    }),
  );
}
